module.exports = __webpack_public_path__ + "img/johnston-county-logo.1ae07400.jpg";